import { render, staticRenderFns } from "./SelfStudyManagement.vue?vue&type=template&id=d448beac&"
import script from "./SelfStudyManagement.vue?vue&type=script&lang=js&"
export * from "./SelfStudyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports